import { X } from "lucide-react";
import type { DataRecord } from "../types";

export function DetailDrawer({ title, value, onClose }: { title: string; value: DataRecord | null; onClose: () => void }) {
  if (!value) return null;
  return (
    <div className="drawer-backdrop" role="presentation" onMouseDown={(event) => event.target === event.currentTarget && onClose()}>
      <aside className="detail-drawer" aria-label={`${title} details`}>
        <header className="drawer-header">
          <div>
            <p className="eyebrow">Record detail</p>
            <h2>{title}</h2>
          </div>
          <button className="icon-button" type="button" onClick={onClose} title="Close details"><X size={18} /></button>
        </header>
        <dl className="detail-list">
          {Object.entries(value).map(([key, item]) => (
            <div key={key} className="detail-row">
              <dt>{humanize(key)}</dt>
              <dd>{renderDetail(item)}</dd>
            </div>
          ))}
        </dl>
      </aside>
    </div>
  );
}

function renderDetail(value: unknown) {
  if (value === null || value === undefined || value === "") return <span className="empty-value">None</span>;
  if (typeof value === "object") return <pre>{JSON.stringify(value, null, 2)}</pre>;
  return String(value);
}

export function humanize(value: string): string {
  return value.replace(/([a-z0-9])([A-Z])/g, "$1 $2").replaceAll("_", " ").replace(/^./, (letter) => letter.toUpperCase());
}
